module.exports = __webpack_public_path__ + "img/11.fbf1fb5e.jpg";